import type { RuleEngineEndpoint } from '../../domain'

export interface RuleEngineService {
    /**
     * @throws {import('../../domain').ConnectwareError}
     * @throws {import('../../domain').CybusRuleEngineExecutionError}
     */
    transform(input: unknown, transformationExpression: string): Promise<unknown>

    /**
     * @throws {import('../../domain').ConnectwareError}
     */
    fetchEndpoints(search: string): Promise<readonly RuleEngineEndpoint[]>
}
